import { render } from "./BaseItemGroup.vue?vue&type=template&id=0a22faa5&ts=true"
import script from "./BaseItemGroup.vue?vue&type=script&lang=ts"
export * from "./BaseItemGroup.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__